import { Pipe, PipeTransform } from '@angular/core'
import moment from 'moment-mini'
import { SerieProposalStatus } from '../serie-proposal'
import { SerieProposalService } from '../serie-proposal.service'

@Pipe({
  name: 'getProposalsForProductAndHour',
  pure: true
})
export class GetProposalsForProductPipe implements PipeTransform {
  constructor(private serieProposalService: SerieProposalService) {}
  transform(
    productId: number,
    hour: any,
    productEntities: any,
    selectedDay: any,

    serieProposals: any,
    dependantProductsMap: any,
    seriesProporsalItemEntities: any
  ): any[] {
    return this.serieProposalService.getProposalsForProductAndHour(
      productId,
      hour,
      productEntities,
      selectedDay,

      serieProposals,
      dependantProductsMap,
      seriesProporsalItemEntities
    )
  }
}
